// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NYLaoZkFRKx-Wvb_MyniM"};